// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"98":"c48ca4a7","556":"ed7749da"}[chunkId] + ".js";
};